<div class="am-modal-internal">
    <div class="am-space"></div>
    <div class="am-close-div bg-am-medium-blue">
        <button type="button" class=" text-am-white am-close-x" (click)="closeModal()">
            <img src="../../../../assets/images/close.svg" alt="close">
        </button>
    </div>
    <div class="am-img-alert">
        <img class="am-img-alert-img" alt="" src="../../../../assets/images/alert/warningAlert.svg">
    </div>
    <div class="modal-title txt-garnett-Regular-34">
        <p>{{  'modalNotFoundFlight.subtitleModRef' | translate }}</p>
    </div>
</div>